import { useNewsletterContext } from "../../context/newsletter.context";

const TitleComponent = () => {
    const { alignment, helperText, isBold } = useNewsletterContext();
    return (
        <div
            className={`h5 ${
                isBold ? "font-weight-bold" : ""
            } ${alignment} mt-0`}
        >
            {helperText}
        </div>
    );
};

export { TitleComponent };
